<template>
  <div>
    <img src="@/assets/tarjeta_ofertas_seguro_accidentes.jpg" style="width: 100%" />
    <p class="tituloTarjeta">SEGURO DE ACCIDENTES</p>
    <p>
      Seguro completo para protegerte a ti y a tu familia en situaciones inesperadas. Conoce nuestro nuevo Seguro de
      Accidentes:
    </p>
    <ul style="list-style-type: disc">
      <li>Protección flexible y personalizable</li>
      <li>Asistencia especializada</li>
      <li>Protección integral</li>
      <li>Un seguro para toda la familia</li>
    </ul>
    <p>¡Ante situaciones inesperadas, protección planificada!</p>
    <p class="container-flex">
      <a :href="'tel:' + telefonoOwner">
        <button class="pure-button botonLlamar" title="Pulsa el botón para llamar a tu oficina MMT">
          Llama e infórmate
        </button>
      </a>

    </p>

  </div>
</template>

<script>
/* eslint-disable no-console */
export default {
  data() {
    return {
      telefonoOwner:
        this.$store.state.portfolio.cliente.telefonoOwnerPropioCliente,
    };
  },


};
</script>

<style lang="scss" scoped>
.container-flex {
  margin-top: 2.5rem;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.botonLlamar {
  background-color: $colorMMT;
  color: white;
  font-weight: bold;
  width: 13rem;
  border: 0.15rem solid;
  border-radius: 0.5rem;
  text-align: center;
}

// .container-flex a:first-child {
//   margin-right: 15%;
// }
</style>
